export default __webpack_public_path__ + "static/media/Power_Supply.874b4f08.svg";